export default {
  data() {
    return{
      count: 0
    }
  },
  computed: {
    tags_obj: {
      get (){
        var c = 0
        var t = this.$store.getters.tags;
        for (var key in t) {
          if(t[key].length > 0){
            c++
          }
          if(t[key].key !== undefined) {
            c++
          }
        }
        this.count = c;

        return this.$store.getters.tags;
      },
    },

    tags() {
      let res = [];

      for (const key in this.tags_obj) {
        let val=this.tags_obj[key];
        if (!val) continue;
        if (val.length==0) continue;

        if (Array.isArray(val)) {
          val.forEach( (v)=>{
            let new_item=JSON.parse(JSON.stringify(v));
            new_item.group=key;
            res.push(new_item);
          });
        } else {
          let new_item=JSON.parse(JSON.stringify(val));
          new_item.group=key;
          res.push(new_item);
        }
      }

      let orders=['name', 'saletype',
        'pro', 'picked', 'annotation', 'audioguides', 'video', 'copy_of', 'interior', 'best',
        'price_min', 'price_max',
        'type', 'genre', 'style', 'technique', 'material', 'school',
        'year_from', 'year_to',
        'color', 'size', 'plregion',
        'region',
        'artist', 'gallery',
        'country',
        'place', 'tag', 'preset',
        'liked', 'work',
      ];

      let res_ordered=[];
      orders.forEach((order) => {
        res.forEach((item) => {
          if (item.group==order) res_ordered.push(item);
        });
      });

      res.forEach((item) => {
        if (orders.indexOf(item.group) === -1) res_ordered.push(item);
      });

      return res_ordered;
    },
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/WorksTagsMix.js
// module id = null
// module chunks = 